import i18n from '../../lang/lang';

const FlowHelper = {};

FlowHelper.install = function(Vue, options) {

    const ADMIN = "ADMIN";
    const POWER = "POWER";
    const NORMAL = "NORMAL";

    const NO_BADGE = "NoBadge";
    const ON_THE_WAY = "OnTheWay";
    const AT_WAITING_AREA = "AtWaitingArea";
    const LEFT_WAITING_AREA = "LeftWaitingArea";
    const IN_CONSULTATION = "InConsultation";
    const LEAVING_CONSULTATION = "LeavingConsultation";
    const LEFT_CONSULTATION = "LeftConsultation";

    const STATUS_RANK = {
        InConsultation: 0,
        AtWaitingArea: 1,
        LeftWaitingArea: 2,
        OnTheWay: 3,
        LeavingConsultation: 4,
        LeftConsultation: 5,
        NoBadge: 6
    };

    Vue.setLocale = function(locale) {
        if (locale) {
            i18n.locale = locale;
        }
    };

    Vue.saveOngoingStatusFilters = function (statusesArray) {
        var statuses = "";
        if (statusesArray) {
            statuses = statusesArray.join(",");
        } else {
            statuses = Vue.getAllStatuses().join(",");
        }

        setCookie("status-filters", statuses, 600); //10 hours
    };

    Vue.getOngoingStatusFilters = function() {
        var cookies = document.cookie.split(";");
        var statuses = undefined;

        var key = "status-filters=";
        for (var index in cookies) {
            var cookie = cookies[index].trim();
            if (cookie.startsWith(key)) {
                statuses = cookie.replace(key, "");
            }
        }

        if (!statuses) {
            var allStatuses = this.getAllStatuses();
            setCookie("status-filters", allStatuses.join(","), 600); //10 hours
            return allStatuses;
        } else {
            return statuses.split(",");
        }
    };

    Vue.getYMDFromDMY = getYMDFromDMY;

    Vue.setDateObjectToYMD = setDateObjectToYMD;

    Vue.isCurrentUserAdmin = isCurrentUserAdmin;

    Vue.isCurrentUserAllowedToPrint = isCurrentUserAllowedToPrint;

    function isCurrentUserAdmin() {
        return Vue.prototype.$currentUser.user.role === ADMIN;
    }

    function isCurrentUserNormal() {
        return Vue.prototype.$currentUser.user.role === NORMAL;
    }

    function isCurrentUserPower() {
        return Vue.prototype.$currentUser.user.role === POWER;
    }

    function getYMDFromDMY(date) {
        if (!date) {
            return null;
        }

        var val = date.split("-");
        if (val.length !== 3) {
            return null;
        }

        return val[2] + "-" + val[1] + "-" + val[0];
    }

    function setDateObjectToYMD(date) {
        if (!date) {
            return null;
        }

        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }
        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    function setCookie(key, value, expiryInMins) {
        var now = new Date();
        now.setTime(now.getTime() + (expiryInMins * 60 * 1000));
        document.cookie = key + "=" + value +  ";expires=" + now.toGMTString() + ";path=/";
    }

    Vue.setCookie = setCookie;

    Vue.getCookie = function (key) {
        let pattern = "(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$";
        let regex = new RegExp(pattern, 'g');
        return document.cookie.replace(regex, "$1");
    };

    Vue.getCurrentWardIdCookie = function () {
        return document.cookie.replace(/(?:(?:^|.*;\s*)current-ward\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    };

    Vue.setCurrentWard = function (ward) {
        console.log("Setting ward: " + JSON.stringify(ward));
        document.cookie = "current-ward = " + ward.id;
        Vue.prototype.$currentWard = ward;
        Vue.prototype.$showStatusOverviewMenu = Vue.prototype.$currentWard.uisettings.plugin === 'dh' || Vue.prototype.$currentWard.uisettings.plugin === 'mi';
    };

    Vue.isAdmin = function(role) {
        return role === ADMIN;
    };

    Vue.isPower = function(role) {
        return role === POWER;
    };

    Vue.isNormal = function(role) {
        return role === NORMAL;
    };

    Vue.firstLetterToUppercase = function(string) {
        return string.charAt(0).toLocaleUpperCase() + string.slice(1);
    };

    Vue.patientNamePlusId = patientNamePlusId;

    Vue.scrollToElementWithId = function(elmntId) {
        var elmnt = document.getElementById(elmntId);
        try {
            elmnt.scrollIntoView({behavior: "instant", block: "center", inline: "center"});
        } catch (e) {
            var top = elmnt.offsetTop;
            window.scrollTo(0, top);
        }
    };

    Vue.getStatusRank = function(status) {
        return STATUS_RANK[status];
    };

    Vue.sortByKey = function(array, key) {
        if (array && array.length > 1) {
            array.sort(function (a, b) {
                return a[key].localeCompare(b[key]);
            });
        }
    };

    Vue.sortByKeyInt = function (array, key) {
        if (array && array.length > 1) {
            array.sort(function (a, b) {
                return a[key]-b[key];
            });
        }
    };

    Vue.getAllStatuses = function () {
        return [
            NO_BADGE,
            ON_THE_WAY,
            AT_WAITING_AREA,
            LEFT_WAITING_AREA,
            IN_CONSULTATION,
            LEAVING_CONSULTATION,
            LEFT_CONSULTATION
        ];
    };

    Vue.userHasOnlyNormalAccess = function() {
        const user = Vue.prototype.$currentUser;

        return user.role === ADMIN || user.role === POWER;
    };

    Vue.userHasAGSPhysician = function() {
        const cu = Vue.prototype.$currentUser;

        return cu.user && cu.user.agendaSystemPhysicianId && cu.user.physician;
    };

    Vue.getUserAGSPhysician = function() {
        const cu = Vue.prototype.$currentUser;

        return cu.user ? cu.user.physician : null;
    };

    Vue.getUserAGSPhysicianId = function() {
        const cu = Vue.prototype.$currentUser;

        return (cu.user && cu.user.physician) ? cu.user.physician.id : null;
    };

    Vue.getNormalUserWardId = function () {
        const cu = Vue.prototype.$currentUser;

        if (cu.lwWards && cu.lwWards.length > 0) {
            return cu.lwWards[0].id;
        }

        return null;
    };

    Vue.getRoomActionUISetting = getRoomActionUISetting;

    Vue.extractFastTrackWardAndGroup = function(wardAndGrp, currentWardId) {
        console.log("Extracting ward and group from: '" + wardAndGrp + "' and comparing to currentward: '" + currentWardId + "'");
        var result = [undefined, undefined];
        if (!wardAndGrp) {
            console.log("Invalid FastTrackWardAndGroup. Check setting");
            return result;
        }

        var windex = wardAndGrp.indexOf(".");
        if (windex < 0) {
            console.log("Invalid FastTrackWardAndGroup: Unable to split. Check setting");
            return result;
        }

        var w = wardAndGrp.slice(0, windex);
        if (w !== currentWardId) {
            console.log("Extracted ward: '" + w +"' does not match currentward: '" + currentWardId + "'");
            return result;
        }

        result[0] = w;
        result[1] = wardAndGrp.slice(windex + 1);

        return result;
    };

    function compareStatus(a, b) {
        return STATUS_RANK[a] - STATUS_RANK[b] === 0;
    }

    function patientNamePlusId(name, idsArray) {
        var heading = name;

        if (!idsArray || idsArray.length === 0) {
            return heading;
        }

        return heading + " (" + idsArray.join(",") + ")";
    }

    function getRoomActionUISetting(action, key, fallback) {
        if (!action || !action.uiSettings || !action.uiSettings.entry) {
            return fallback;
        }
        var entries = action.uiSettings.entry;

        for (var i in entries) {
            if (entries[i].key === key) {
                return entries[i].value;
            }
        }

        return fallback;
    }

    function isCurrentUserAllowedToPrint() {
        return isCurrentUserPower() || isCurrentUserAdmin();
    }

    Vue.mixin({

        methods: {
            isStatusNoBadge (status) {
                return compareStatus(status, NO_BADGE);
            },

            isStatusOnTheWay (status) {
                return compareStatus(status, ON_THE_WAY);
            },

            isStatusAtWaitingArea (status) {
                return compareStatus(status, AT_WAITING_AREA);
            },

            isStatusLeftWaitingArea (status) {
                return compareStatus(status, LEFT_WAITING_AREA);
            },

            isStatusInConsultation (status) {
                return compareStatus(status, IN_CONSULTATION);
            },

            isStatusLeavingConsultation (status) {
                return compareStatus(status, LEAVING_CONSULTATION);
            },

            isStatusLeftConsultation (status) {
                return compareStatus(status, LEFT_CONSULTATION);
            },

            getAllStatuses() {
                return [
                    NO_BADGE,
                    ON_THE_WAY,
                    AT_WAITING_AREA,
                    LEFT_WAITING_AREA,
                    IN_CONSULTATION,
                    LEAVING_CONSULTATION,
                    LEFT_CONSULTATION
                ];
            },

            recallAppointment(patientId, appointmentId) {
                var app = this;
                Vue.prototype.$frc.recallAppointment(patientId, appointmentId).then(function(res) {
                    Vue.notifySuccess({title: i18n.t("patientCalled")});
                });
            },

            getRoomActionUISetting(action, key, fallback) {
                return getRoomActionUISetting(action, key, fallback);
            },

            getYMDFromDMY(date) {
                return getYMDFromDMY(date);
            },

            getPatientNameWithId(name, ids) {
                return patientNamePlusId(name, ids);
            },

            isCurrentUserAdmin() {
                return isCurrentUserAdmin();
            },

            isCurrentUserNormal() {
                return isCurrentUserNormal();
            },

            isCurrentUserPower() {
                return isCurrentUserPower();
            },

            isCurrentUserAllowedToPrint() {
                return isCurrentUserAllowedToPrint();
            }

        }
    });
    
};

export default FlowHelper;